import type { QuoteStep } from '../types/quote.types';

// Payment precedes Customer in both orders: the two gates are independent, reading only
// `paymentSelection` and `selectedCustomer` respectively.
export const DEALER_FIRST_ORDER = [
    'dealer', 'vehicle', 'product', 'configuration', 'payment', 'customer', 'summary',
] as const satisfies readonly QuoteStep[];

export const DEALER_DEFERRED_ORDER = [
    'vehicle', 'product', 'configuration', 'payment', 'dealer', 'customer', 'summary',
] as const satisfies readonly QuoteStep[];

// Used when the user can see exactly one dealer, which is picked for them.
export const DEALER_AUTO_SELECTED_ORDER = [
    'vehicle', 'product', 'configuration', 'payment', 'customer', 'summary',
] as const satisfies readonly QuoteStep[];

export const resolveStepOrder = (defer: boolean, dealerAutoSelected = false): readonly QuoteStep[] => {
    if (dealerAutoSelected) return DEALER_AUTO_SELECTED_ORDER;
    return defer ? DEALER_DEFERRED_ORDER : DEALER_FIRST_ORDER;
};

/** The step a journey parked on `dealer` moves to once the dealer step is skipped. */
export const stepAfterSkippedDealer = (defer: boolean): QuoteStep => {
    const order: readonly QuoteStep[] = resolveStepOrder(defer);
    return order[order.indexOf('dealer') + 1];
};
